module.exports = __webpack_public_path__ + "static/media/schody23 - schody drewniane lakierowane z podestem.95f5fe89.jpg";